import React, {Component} from 'react';
import Slideout from 'slideout';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import utilities from '../../utilities/utilities';
import * as actionCreators from '../../store/actions';

const propTypes = {
  children: PropTypes.instanceOf(Object).isRequired,
  userData: PropTypes.instanceOf(Object).isRequired,
  toggleLeftOverlay: PropTypes.func.isRequired,
};

class SideNav extends Component {
  constructor(props) {
    super(props);

    this.slideout = null;
    this.toggleMenu = this.toggleMenu.bind(this);
  }

  componentDidMount() {
    const panel = document.getElementById('side-panel');
    const menu = document.getElementById('side-nav-menu');
    this.slideout = new Slideout({
      panel,
      menu,
      padding: 256,
      tolerance: 70,
      side: 'right',
    });
    this.slideout.on('beforeopen', () => {
      panel.classList.remove('hide');
      menu.style.transform = null;
    });
    this.slideout.on('close', () => {
      panel.classList.add('hide');
      menu.style.transform = null;
    });
    this.slideout.on('translate', (translated) => {
      menu.style.transform = `translateX(${menu.offsetWidth - Math.abs(translated)}px)`;
    });
    panel.addEventListener('click', this.toggleMenu);
  }

  componentWillUnmount() {
    this.slideout.destroy();
  }

  toggleMenu() {
    const {toggleLeftOverlay} = this.props;
    toggleLeftOverlay('');
    this.slideout.toggle();
  }

  userAvatar() {
    const {userData} = this.props;
    if (utilities.isLoggedIn(userData)) {
      const userName = `${userData.field_user_first_name} ${userData.field_user_last_name}`;
      return (
        <span className="avatar">
          <img alt="Avatar" src={userData.picture} title={userName} />
        </span>
      );
    }
    return <span className="avatar placeholder" title="Login" />;
  }

  render() {
    const {children} = this.props;
    return (
      <div className="side-nav-wrapper">
        <button
          type="button"
          onClick={this.toggleMenu}
          className="side-nav-menu-toggler button-link"
        >
          {this.userAvatar()}
        </button>
        <div id="side-nav-menu" className="side-nav-menu">
          <div className="side-nav-menu-inner">{children}</div>
        </div>
        <div className="side-panel hide" id="side-panel" />
      </div>
    );
  }
}

SideNav.propTypes = propTypes;

const mapStateToProps = state => ({
  userData: state.user.userData,
  isMobile: state.ui.isMobile,
});

const mapDispatchToProps = dispatch => ({
  toggleLeftOverlay: name => dispatch(actionCreators.toggleLeftOverlay(name)),
});

export default connect(mapStateToProps, mapDispatchToProps, null, {forwardRef: true})(SideNav);
